<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">	
			<top-nevleft></top-nevleft>
			
		 <b-col class="p-0">
		 <b-row class="breadcrumbrow mt-1 m-0">				
			<b-col>
			 <h5 class="text-center">Admin Dashboard</h5>
			</b-col>				
		 </b-row>
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-4 col-sm-4 col-xs-4 text-left">
					<!-- <h3>Marketing Data</h3> -->
				</b-col>
				<b-col class="col-md-8 col-sm-8 col-xs-8 text-right">
					
					 
					 <download-csv type="button" class="btn btn-dark rounded-pill ml-2"  :data="recordsCsv" name="comm_report.csv" ><b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Export CSV</download-csv>
				</b-col>
			</b-row>
		</b-container>
		
		<b-container fluid>
			
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<!--<b-row class="mt-4 px-3">
					
						<b-col  >
							<span class="mr-2">Show</span>
							<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
							</b-form-select>
							<b-button size="sm ml-3 mr-2" @click="selectAllRows">Select all</b-button>
							<b-button size="sm mr-2" @click="clearSelected">Clear selected</b-button>
							
						 </b-col>
						 <b-col class="text-right">
							<b-button size="sm ml-3 mr-2" @click="activateUsers">Activate Users</b-button>
							
						 </b-col>
						</b-row> -->
					
					
						<b-row class="mt-4 px-3">
							<b-col lg="3" class="text-left">
							<span class="mr-2">&nbsp;</span>
								<span class="mr-2">&nbsp;</span>
								<b-form-checkbox v-model="commissionFilter" id="commissionFilter-a" value="1" unchecked-value="0"> 
									Zero Commission 
								</b-form-checkbox>
							</b-col>
							<b-col lg="2" class="text-left">
								<span class="mr-2">&nbsp;</span>
								<b-form-checkbox v-model="discountFilter" id="discountFilterFilter-a" value="1" unchecked-value="0"> 
									Zero Discount 
								</b-form-checkbox>
							</b-col>
							<!--	
							<b-col lg="2" class="text-left">
								<span class="mr-2">Seller</span>
								<b-form-select v-model="reg_seller" required>
									<b-form-select-option value="0">All</b-form-select-option>
									<b-form-select-option v-for="sellerRor in sellerList" :value="sellerRor.user_id"  :key="sellerRor.user_id" >{{sellerRor.seller_name || sellerRor.seller_email }}</b-form-select-option>
									
								</b-form-select>
							</b-col> -->
							<b-col lg="2" class="text-left">
								<span class="mr-2">Brand</span>
								<b-form-select v-model="reg_brand" required>
									<b-form-select-option value="null">All Brand</b-form-select-option>
									<b-form-select-option v-for="sellerRor in sellerList" :value="sellerRor.brand_name"  :key="sellerRor.user_id" >{{sellerRor.brand_name}}</b-form-select-option>
									
								</b-form-select>
							</b-col>
							<b-col lg="2" class="text-left">
								<b-button pill variant="primary" class="mt-4" @click="loadData()" size="sm">Submit</b-button>
							</b-col>
							
							<b-col lg="3">
								<span class="mr-2">Filter</span>
								<b-input-group >
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" ref="selectableTable" selectable @row-selected="onRowSelected">
									<template v-slot:cell(selected)="{ rowSelected }">
											<template v-if="rowSelected">
										  <span aria-hidden="true">&check;</span>
										  <span class="sr-only">Selected</span>
										</template>
										<template v-else>
										  <span aria-hidden="true">&nbsp;</span>
										  <span class="sr-only">Not selected</span>
										</template>
									</template>
									
								
								
									<template v-slot:cell(insert_time)="row">
										<span>{{$moment(row.value).format('DD-MM-YYYY HH:mm:ss')}}</span>
									</template>
									
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<top-footer></top-footer>
	</b-col>
	</b-row>		
	</b-container>
	</div>
	
</template>
<script>
//import Header from "@/components/admin/Header.vue";
import Header from "@/components/header.vue";
import Footer from "@/components/footer-admin.vue";
import TreeviewPage from "@/components/admin/nevleft.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
			loading: true, 
			
			datefrom: '',
			dateto: '',
			reg_status: -1,
			reg_role: '',         
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            product_inf: {},
			/*product_glb: '',*/
			model_maps: {},
			//recordUrl: this.$root.WEBAPI+'secureapi/registration-reload',
			recordUrl: this.$root.WEBAPI+'secureapi/salespromotion',
			
			
			updateUrl: this.$root.WEBAPI+'secureapi/registration-update',
			convertUrl: this.$root.WEBAPI+'secureapi/registration-convert',
			importUrl: this.$root.NEWAPIURL+'secureapi/marketing-import',
			activateBulkUserUrl: this.$root.WEBAPI+'secureapi/registration-convert-bulk',
			recordsCsv: [],
			sellerList: [],
			records: [],
			categoryOptions: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Products',
					active: true
				}
			],
			fields: [
				 /*{ key: 'Selected',label: 'Selected'}, */
                { key: 'id', label: 'ID'},
                { key: 'seller_name', label: 'Seller Name'},
               /* { key: 'seller_email', label: 'Seller Email'},*/
                { key: 'sku', label: 'SKU'},
				{ key: 'commission', label: 'Commission (in %)'},
				{ key: 'discount', label: 'Discount (in %)' },
				/*{ key: 'reg_status', label: 'Status'},
				{ key: 'account_created', label: 'Account'},*/
               
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [25,50,100,200,300,500],
			perPage: 25,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {product_data:{}, tier_price:[]},
			emptyItem: {
				id: 0,
				product_id: '',
				title: '',
				short_description: '',
				description: '',
				sku: '',
				category: '',
				price: '',
				special_price: '',
				product_data:{},
				tier_price: [],
                status: 0
			},
			counterindex:1,
			selected:[],
			reg_seller:0,
			reg_brand:null,
			discountFilter:0,
			commissionFilter:0
		};
	},
	methods: {
		removeTierPrice(i){
			this.selectedItem.tier_price.splice(i,1);
		},
		addTierPrice(){
			console.log(JSON.stringify(this.selectedItem.tier_price));
			var d = new Date();
			this.selectedItem.tier_price.push({'id':d.getTime(), 'min_qty':0, 'price':0});
		},
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showCommentModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			if(item.comment){
				this.selectedItem.comment = JSON.parse(item.comment);
			}
			this.$root.$emit('bv::show::modal', 'comment-model', button)
		},
		processRole(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to add user account.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.convertUrl, {
						accesskey: self.$session.get('access_key'),
						data: item
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
						}
                                                self.initload();
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key'),
				brandName: self.reg_brand,
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.records;
					self.sellerList = response.data.result.sellerList;
					self.loading = false;
					self.totalRows = self.records.length;
					self.recordsCsv=[];
					console.log('selfRecordsCsv:'+self.recordsCsv);
					self.records.forEach(item => {
						var arrayCsv={'Seller Name':item.seller_name,'SKU':item.sku,'Commission (in %)':item.commission,'Discount (in %)':item.discount};					
						self.recordsCsv.push(arrayCsv);
					});
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		loadData(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key'),				
				seller_id: self.reg_seller,
				brandName: self.reg_brand,
				discountFilter: self.discountFilter,
				commissionFilter: self.commissionFilter
				

			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.records;
					self.loading = false;
					self.totalRows = self.records.length;
					//self.sellerList = response.data.result.sellerList;
					self.recordsCsv=[];
					self.records.forEach(item => {
						var arrayCsv={'Seller Name':item.seller_name,'SKU':item.sku,'Commission (in %)':item.commission,'Discount (in %)':item.discount};					
						self.recordsCsv.push(arrayCsv);
					});
					

				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		
		/*Email SEND */
		onRowSelected(items) {
			this.selected = items
		  },
		selectAllRows() {
			this.$refs.selectableTable.selectAllRows()
		  },
		  clearSelected() {
			this.$refs.selectableTable.clearSelected()
		  },
		activateUsers(){
				var self = this;
				this.$bvModal.msgBoxConfirm('Please confirm that you want to Activate Users!.', {
					title: 'Please Confirm',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: 'YES',
					cancelTitle: 'NO',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if(value == true){
						
						self.axios.post(self.activateBulkUserUrl, {
							accesskey: self.$session.get('access_key'),
							user_data: self.selected
						})
						.then(function (response) {
							if(response.data.error == 0 || response.data.error == '0'){
								self.$bvToast.toast(response.data.message, {
									title: 'Email Status',
									toaster: 'b-toaster-bottom-right',
									autoHideDelay: 5000,
									variant: 'success',
									solid: true,
									appendToast: true
								});
								//self.initload();
							}else{
							
								self.$bvToast.toast(response.data.message, {
									title: 'Email Status',
									toaster: 'b-toaster-bottom-right',
									autoHideDelay: 5000,
									variant: 'warning',
									solid: true,
									appendToast: true
								});
							
							}
							
						})
						.catch(function (error) {
							alert(error);
						});
					}else{
						//alert('no '+item.id);
					}
				})
				.catch(err => {
					// An error occurred
					console.log(err);
				})
		}
	}
}
</script>

<style>
.displaynon{
display:none;
}
</style>